// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3OfAR","inputWrap":"styles_inputWrap__1BjPn","input":"styles_input__-RFWL"};